import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { selectActiveRingByID } from "../../redux/actions";
import "./_DiamondSizeSelector.scss";

class DiamondSizeSelector extends React.Component {
  onSizeButtonPress = (bigger = true) => {
    const { mainRings, activeMainRing } = this.props;
    if (mainRings && activeMainRing) {
      const filteredRings = this.filterRings(mainRings, activeMainRing)
        .sort(function (a, b) {
          if (bigger) {
            return a.fields.diamondSize - b.fields.diamondSize;
          } else {
            return b.fields.diamondSize - a.fields.diamondSize;
          }
        })
        .filter((item) => {
          if (bigger) {
            return item.fields.diamondSize > activeMainRing.fields.diamondSize;
          } else {
            return item.fields.diamondSize < activeMainRing.fields.diamondSize;
          }
        });
      if (filteredRings && filteredRings.length) {
        this.changeURL(filteredRings[0]);
      }
    }
  };

  filterRings = (mainRings, activeMainRing) => {
    const currentCollection = activeMainRing.fields.collectionTitle
      ? activeMainRing.fields.collectionTitle
      : null;
    const currentSubCollectionID = activeMainRing.fields.subCollection
      ? activeMainRing.fields.subCollection.sys.id
      : null;
    if (currentCollection) {
      const currentCollectionRings = this.filterByMainCollection(
        mainRings.items,
        currentCollection
      );
      if (currentSubCollectionID) {
        return this.filterBySubCollection(
          currentCollectionRings,
          currentSubCollectionID
        );
      }
      return currentCollectionRings;
    }
    return null;
  };

  filterByMainCollection = (listOfRings, collection) => {
    if (listOfRings && listOfRings.length && collection) {
      return listOfRings.filter((item) => {
        return item.fields.collectionTitle === collection;
      });
    }
    return null;
  };

  filterBySubCollection = (listOfRings, subCollectionID) => {
    if (listOfRings && listOfRings.length && subCollectionID) {
      return listOfRings.filter((item) => {
        if (item.fields.subCollection) {
          return item.fields.subCollection.sys.id === subCollectionID;
        }
        return null;
      });
    }
    return null;
  };

  changeURL = (newItem) => {
    const { history } = this.props;
    const oldParams = history ? history.location.search.split("&") : null;
    if (oldParams && newItem) {
      for (let i = 0; i < oldParams.length; i++) {
        if (oldParams[i].split("=")[0] === "ring") {
          oldParams[i] = "ring=" + newItem.sys.id;
        }
      }
    }
    const newSearchParams = oldParams.join("&");
    this.props.selectActiveRingByID(newItem.sys.id);
    history.push({
      pathname: "/",
      search: newSearchParams,
    });
  };

  renderControls = (activeRing) => {
    let diamondSize = 0.5;
    if (activeRing && activeRing.fields) {
      diamondSize = activeRing.fields.diamondSize;
    }
    return (
      <div className="diamond-controls">
        <button
          onClick={() => this.onSizeButtonPress(false)}
          className="half-button button-minus"
        >
          -
        </button>
        <span className="diamond-size">{diamondSize} ct</span>
        <button
          onClick={() => this.onSizeButtonPress()}
          className="half-button button-plus"
        >
          +
        </button>
      </div>
    );
  };

  render() {
    const { activeMainRing, title } = this.props;
    return (
      <div className="diamond-size-selector">
        <span className="component-title">{title}</span>
        {this.renderControls(activeMainRing)}
      </div>
    );
  }
}

const mapStateToProps = ({ ring }) => {
  const { activeMainRing, mainRings } = ring;

  return {
    activeMainRing,
    mainRings,
  };
};

export default connect(mapStateToProps, { selectActiveRingByID })(
  withRouter(DiamondSizeSelector)
);
